(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-title', {
            parent: 'entity',
            url: '/customer-title?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerTitle.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-title/customer-titles.html',
                    controller: 'CustomerTitleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerTitle');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-title-detail', {
            parent: 'entity',
            url: '/customer-title/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerTitle.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-title/customer-title-detail.html',
                    controller: 'CustomerTitleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerTitle');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerTitle', function($stateParams, CustomerTitle) {
                    return CustomerTitle.get({id : $stateParams.id});
                }]
            }
        })
        .state('customer-title.new', {
            parent: 'customer-title',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-title/customer-title-dialog.html',
                    controller: 'CustomerTitleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-title', null, { reload: true });
                }, function() {
                    $state.go('customer-title');
                });
            }]
        })
        .state('customer-title.edit', {
            parent: 'customer-title',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-title/customer-title-dialog.html',
                    controller: 'CustomerTitleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerTitle', function(CustomerTitle) {
                            return CustomerTitle.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-title', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-title.delete', {
            parent: 'customer-title',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-title/customer-title-delete-dialog.html',
                    controller: 'CustomerTitleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerTitle', function(CustomerTitle) {
                            return CustomerTitle.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-title', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
